import React from 'react';

import CheckIcon from '../../../../../../assets/icons/benchmark/check.svg';
import ClockIcon from '../../../../../../assets/icons/benchmark/clock.svg';
import XmarkIcon from '../../../../../../assets/icons/benchmark/xmark.svg';

export const icons = {
  checkMark: <img width={'12px'} height={'12px'} src={CheckIcon} alt="check.svg" />,
  clockMark: <img width={'12px'} height={'12px'} src={ClockIcon} alt="clock.svg" />,
  xMark: <img width={'12px'} height={'12px'} src={XmarkIcon} alt="xmark.svg" />,
};

interface Props {
  icon: keyof typeof icons;
}

const ResolutionIcon: React.FC<Props> = ({ icon }) => {
  return <>{icons[icon]}</>;
};

export default ResolutionIcon;
